import { h, Component } from 'preact'
import {
  colors,
  supportColors,
  administrationDisclaimer,
} from '../../constants'
import { AnimatedCenterOrLeft } from '../visual'
import Support from './Support'

import * as svgs from '../svgs'

const Image = ({ partyLogo, img, height = 170 }) => (
  <div>
    <div
      style={{
        position: 'relative',
        margin: '21px 21px 0 0',
        display: 'inline-block',
      }}
    >
      <div
        style={{
          width: height / 170 * 140,
          height,
          backgroundImage: `url(https://rekonstrukcestatu.cz/${img})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          WebkitFilter: 'grayscale(100%)',
          filter: 'grayscale(100%)',
        }}
      />
      {partyLogo ? (
        <object
          data={`https://rekonstrukcestatu.cz/${partyLogo}`}
          type="image/jpg"
          className="party-logo"
          width="52"
          height="52"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            transform: 'translate(40%, -40%)',
          }}
        >
          <img
            alt=""
            src={`https://rekonstrukcestatu.cz/${partyLogo}`}
            type="image/jpg"
            className="party-logo"
            width="52"
            height="52"
            style={{
              borderRadius: 26,
              position: 'absolute',
              top: 0,
              right: 0,
              transform: 'translate(40%, -40%)',
            }}
          />
        </object>
      ) : null}
    </div>
  </div>
)

const Name = ({ name, center }) => (
  <h1 style={{ marginBottom: 0 }}>
    <AnimatedCenterOrLeft animate={false} center={center}>
      <span>{name.firstname}</span> <span>{name.surname}</span>
    </AnimatedCenterOrLeft>
  </h1>
)

const InfoLine = ({ person, center }) => (
  <div className="light last">
    <AnimatedCenterOrLeft animate={false} center={center}>
      {person.affiliationType[0].toUpperCase() +
        person.affiliationType.slice(1)}{' '}
      {person.party}, {person.region},{' '}
      {(() => {
        if (person.gender === 'M')
          return person.type === 'senator' ? 'Senátor' : 'Poslanec'
        else return person.type === 'senator' ? 'Senátorka' : 'Poslankyně'
      })()}
    </AnimatedCenterOrLeft>
  </div>
)

const NameAndInfo = ({ person, center }) => (
  <div
    style={{
      fontSize: '22px',
      lineHeight: '36px',
    }}
  >
    <Name name={person.name} center={center} />
    <InfoLine person={person} center={center} />
  </div>
)

const Statement = ({ link, gender, inline }) =>
  !link ? null : (
    <div
      style={{
        height: 40,
        display: 'inline-block',
        margin: '15px 0 0 0',
      }}
    >
      <a
        href={link}
        style={{
          display: inline ? 'block' : 'inline-block',
          height: inline ? 50 : 'auto',
          marginTop: 10,
          position: 'relative',
          width: 150,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 150,
          }}
        >
          <svgs.Bubble />
          <div
            style={{
              display: 'inline-block',
              width: 100,
              lineHeight: '1em',
            }}
          >
            vyjádření {gender === 'M' ? 'politika' : 'političky'}
          </div>
        </div>
      </a>
    </div>
  )

const StatementAndSupport = ({
  administration,
  support,
  small,
  link,
  gender,
}) => (
  <AnimatedCenterOrLeft animate={false} center={!small}>
    <Support
      support={support}
      margin={!!link}
      administration={administration}
    />
    <Statement link={link} gender={gender} />
  </AnimatedCenterOrLeft>
)

const RankBar = ({ val: _val, outOf, color, bgcolor = colors.grey }) => {
  let val
  if (!Number.isFinite(_val)) return <div />
  else val = _val
  const height = 100
  return (
    <div style={{ height, position: 'relative', width: 70, textAlign: 'left' }}>
      <div
        style={{
          fontFamily: 'bariol,arial,sans-serif',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '2em',
          color: colors.middleGrey,
          textAlign: 'right',
          right: 30,
        }}
      >
        {val}.
      </div>
      <div
        style={{
          width: 10,
          display: 'inline-block',
          position: 'absolute',
          right: 0,
        }}
      >
        <div
          style={{ backgroundColor: bgcolor, height: height * val / outOf }}
        />
        <svgs.RankArrow />
        <div
          style={{ backgroundColor: color, height: height * (1 - val / outOf) }}
        />
      </div>
    </div>
  )
}

const Disclaimer = ({ show, left }) =>
  !show ? null : (
    <AnimatedCenterOrLeft center={!left} animate={false}>
      <div
        style={{ maxWidth: 500, margin: left ? 0 : '0 auto' }}
        className="lt930"
      >
        {administrationDisclaimer.replace(/<br>/g, ' ')}
      </div>
    </AnimatedCenterOrLeft>
  )

class HeaderSection extends Component {
  render() {
    const { person, all, pledge, party, small } = this.props
    return (
      <div>
        <div
          style={{
            position: 'relative',
            marginBottom: 15,
            minHeight: 220,
          }}
        >
          {/* left column */}
          <div
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              transform: `translate(20px, ${small ? 30 : 30}px)`,
              position: 'absolute',
              width: '20%',
            }}
          >
            <Image img={person.img} partyLogo={party.logoURL} height={169} />
          </div>
          {/* middle column */}
          <div
            style={{
              verticalAlign: 'middle',
              paddingLeft: small ? 200 : 0,
            }}
          >
            <NameAndInfo person={person} center={!small} />
            <StatementAndSupport
              support={all.category}
              small={small}
              link={pledge.link}
              gender={person.gender}
              administration={person.administration}
            />
            <Disclaimer show={person.administration} left={small} />
          </div>
          {/* right column, or next line on small */}
          {Number.isFinite(all.rank.total) && !small ? (
            <div
              style={{
                position: 'absolute',
                top: 30,
                right: 20,
                width: 120,
                textAlign: 'right',
              }}
            >
              <div
                style={{
                  fontSize: '1.5em',
                  marginBottom: 5,
                  position: 'relative',
                }}
              >
                <div style={{ position: 'absolute', top: -6 }}>
                  <svgs.RankIcon />
                </div>
                Pořadí
              </div>
              <div style={{ display: 'inline-block' }}>
                <RankBar
                  val={all.rank.total}
                  outOf={person.type === 'MOP' ? 200 : 81}
                  color={supportColors[all.category] || supportColors.nehlasuje}
                />
              </div>
              <div>
                {person.type === 'MOP'
                  ? 'z 200 poslanců ve sněmovně'
                  : 'z 81 senátorů'}
              </div>
            </div>
          ) : null}
        </div>
        {Number.isFinite(all.rank.total) && small ? (
          <div style={{ padding: 10, textAlign: 'center' }}>
            <div style={{ background: colors.grey }}>
              <div
                style={{
                  width: '30%',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  textAlign: 'left',
                }}
              >
                <div style={{ display: 'inline-block', fontSize: '1.5em' }}>
                  <svgs.RankIcon
                    style={{ transform: 'scale(1.5)', marginRight: 15 }}
                  />
                  Pořadí
                </div>
              </div>
              <div
                style={{
                  width: '20%',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  textAlign: 'right',
                  padding: 10,
                }}
              >
                <div style={{ display: 'inline-block' }}>
                  <RankBar
                    bgcolor={colors.greyOnGrey}
                    val={all.rank.total}
                    outOf={person.type === 'MOP' ? 200 : 81}
                    color={
                      supportColors[all.category] || supportColors.nehlasuje
                    }
                  />
                </div>
              </div>
              <div
                style={{
                  width: '33%',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  textAlign: 'left',
                  padding: 20,
                }}
              >
                <div style={{ display: 'inline-block' }}>
                  {person.type === 'MOP'
                    ? 'z 200 poslanců ve sněmovně'
                    : 'z 81 senátorů'}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

export default HeaderSection



// WEBPACK FOOTER //
// ./components/PoliticianDetail/PoliticianSummary.js